import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';
import { DialogModule } from '@ng-falcon/dialog/dialog.module';
import { ArticleCardComponent } from './article-card/article-card.component';
import { RecommendationsComponent } from './recommendations';
import { SingleArticleComponent } from './single-article';
import { SingleResourceComponent } from './single-resource/single-resource.component';
import { ArticleFormComponent } from './article-form/article-form.component';
import { SlugInputComponent } from './slug-input/slug-input.component';
import { DeleteBtnComponent } from './delete-btn/delete-btn.component';
import { TagSelectorComponent } from './tag-selector/tag-selector.component';
import { ArticlesComponent } from './articles/articles.component';
import { PendingArticleComponent } from './pending-article/pending-article.component';
import { CommunityModule } from '../common/community/community.module';
import { CommonComponentsModule } from '../common/components/common-components.module';
import { SharedModule } from '../shared/shared.module';
import { UtEditorModule } from '../common/ut-editor/ut-editor.module';
import { EmojiHtmlPipe } from '../pipes/emoji-html.pipe';
import { EmojiTextPipe } from '../pipes/emoji-text.pipe';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CommonComponentsModule,
    CommunityModule,
    SharedModule,
    UIRouterModule,
    UtEditorModule,
    DialogModule,
    ArticleCardComponent,
    EmojiHtmlPipe,
    EmojiTextPipe,
  ],
  declarations: [
    RecommendationsComponent,
    SingleArticleComponent,
    SingleResourceComponent,
    ArticleFormComponent,
    SlugInputComponent,
    DeleteBtnComponent,
    TagSelectorComponent,
    ArticlesComponent,
    PendingArticleComponent,
  ],
  exports: [
    ArticleCardComponent,
    RecommendationsComponent,
    SingleArticleComponent,
    SingleResourceComponent,
    ArticleFormComponent,
    SlugInputComponent,
    DeleteBtnComponent,
    TagSelectorComponent,
    ArticlesComponent,
    PendingArticleComponent,
  ],
})
class ArticleModule {}

export { ArticleModule };
